var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 55,
    viewBox: "0 0 92 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9301 20.2371V8.79883H74.143V20.2371H62.5688V25.9563H74.143V37.3946H79.9301V25.9563H91.5043V20.2371H79.9301Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0687 21.9967V32.9951H43.8107C41.5125 39.3961 35.3248 43.9935 28.0687 43.9935C18.865 43.9935 11.3751 36.5916 11.3751 27.4959C11.3751 18.4003 18.865 10.9984 28.0687 10.9984C32.0584 10.9984 35.8979 12.4117 38.8805 14.9798L46.1923 6.68701C41.1842 2.37565 34.7517 0 28.0687 0C12.7273 0 0.246094 12.3347 0.246094 27.4959C0.246094 42.6572 12.7273 54.9918 28.0687 54.9918C43.41 54.9918 55.8913 42.6572 55.8913 27.4959V21.9967H28.0687Z",
    fill: "#00ADEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google+.6379062d4f6372b086bde424edc650d1.svg";
export { ForwardRef as ReactComponent };